// super admin
export const userRolesAdmin = [{
    name: "base",
    crud: ["create", "read", "update", "delete", "admin"],
    isAdditionalRole: false
}, {
    name: "package",
    crud: ["create", "read", "update", "delete", "admin"],
    isAdditionalRole: false
}, {
    name: "color",
    crud: ["create", "read", "update", "delete", "admin"],
    isAdditionalRole: false
}, {
    name: "pigment",
    crud: ["create", "read", "update", "delete", "admin"],
    isAdditionalRole: false
}, {
    name: "seller",
    crud: ["create", "read", "update", "delete", "admin"],
    isAdditionalRole: false
}, {
    name: "customer",
    crud: ["create", "read", "update", "delete", "admin"],
    isAdditionalRole: false
}, {
    name: "receipt",
    crud: ["create", "read", "update", "delete", "admin"],
    isAdditionalRole: false
}, {
    name: "toning",
    crud: ["create", "read", "update", "delete", "admin"],
    isAdditionalRole: false
}, {
    name: "user",
    crud: ["create", "read", "update", "delete", "admin"],
    isAdditionalRole: false
}, {
    name: "product",
    crud: ["create", "read", "update", "delete", "admin"],
    isAdditionalRole: false
}, {
    name: "sampleCard",
    crud: ["create", "read", "update", "delete", "admin"],
    isAdditionalRole: false
}, {
    name: "order",
    crud: ["create", "read", "update", "delete", "admin"],
    isAdditionalRole: false
}, {
    name: "discount",
    crud: ["create", "read", "update", "delete", "admin"],
    isAdditionalRole: false
}, {
    name: "hardener",
    crud: ["create", "read", "update", "delete", "admin"],
    isAdditionalRole: false
}, {
    name: "priceList",
    isAdditionalRole: true,
    isAuthorizedForAdditionalRole: true
}, {
    name: "copyReceipt",
    isAdditionalRole: true,
    isAuthorizedForAdditionalRole: true
}, {
    name: "customReceipts",
    isAdditionalRole: true,
    isAuthorizedForAdditionalRole: true
}
]

// obchodni zastupce
export const userRolesSalesManager = [{
    name: "base",
    crud: ["read"],
    isAdditionalRole: false
}, {
    name: "package",
    crud: ["read"],
    isAdditionalRole: false
}, {
    name: "color",
    crud: ["read"],
    isAdditionalRole: false
}, {
    name: "pigment",
    crud: ["read"],
    isAdditionalRole: false
}, {
    name: "seller",
    crud: ["create", "read", "update"],
    isAdditionalRole: false
}, {
    name: "customer",
    crud: ["read"],
    isAdditionalRole: false
}, {
    name: "receipt",
    crud: ["read"],
    isAdditionalRole: false
}, {
    name: "toning",
    crud: ["read"],
    isAdditionalRole: false
}, {
    name: "user",
    crud: ["create", "read", "update"],
    isAdditionalRole: false
}, {
    name: "product",
    crud: ["read"],
    isAdditionalRole: false
}, {
    name: "sampleCard",
    crud: ["read"],
    isAdditionalRole: false
}, {
    name: "order",
    crud: ["create", "read", "update"],
    isAdditionalRole: false
}, {
    name: "discount",
    crud: ["create", "read", "update"],
    isAdditionalRole: false
}, {
    name: "hardener",
    crud: ["read"],
    isAdditionalRole: false
}, {
    name: "priceList",
    isAdditionalRole: true,
    isAuthorizedForAdditionalRole: false
}, {
    name: "customReceipts",
    isAdditionalRole: true,
    isAuthorizedForAdditionalRole: true
}
]

// prodejce majitel
export const userRolesSellerOwner = [{
    name: "base",
    crud: ["read"],
    isAdditionalRole: false
}, {
    name: "package",
    crud: ["read"],
    isAdditionalRole: false
}, {
    name: "color",
    crud: ["read"],
    isAdditionalRole: false
}, {
    name: "pigment",
    crud: ["read"],
    isAdditionalRole: false
}, {
    name: "customer",
    crud: ["read"],
    isAdditionalRole: false
}, {
    name: "toning",
    crud: ["read"],
    isAdditionalRole: false
}, {
    name: "user",
    crud: ["read"],
    isAdditionalRole: false
}, {
    name: "product",
    crud: ["read"],
    isAdditionalRole: false
}, {
    name: "sampleCard",
    crud: ["read"],
    isAdditionalRole: false
}, {
    name: "order",
    crud: ["create", "read", "update"],
    isAdditionalRole: false
}, {
    name: "discount",
    crud: ["create", "read", "update", "delete"],
    isAdditionalRole: false
}, {
    name: "hardener",
    crud: ["read"],
    isAdditionalRole: false
}, {
    name: "priceList",
    isAdditionalRole: true,
    isAuthorizedForAdditionalRole: false
}, {
    name: "customReceipts",
    isAdditionalRole: true,
    isAuthorizedForAdditionalRole: true
}
]

// prodejce micharna - bezny uzivatel
export const userRolesSeller = [{
    name: "base",
    crud: ["read"],
    isAdditionalRole: false
}, {
    name: "package",
    crud: ["read"],
    isAdditionalRole: false
}, {
    name: "color",
    crud: ["read"],
    isAdditionalRole: false
}, {
    name: "pigment",
    crud: ["read"],
    isAdditionalRole: false
}, {
    name: "customer",
    crud: ["read"],
    isAdditionalRole: false
}, {
    name: "toning",
    crud: ["read"],
    isAdditionalRole: false
}, {
    name: "product",
    crud: ["read"],
    isAdditionalRole: false
}, {
    name: "sampleCard",
    crud: ["read"],
    isAdditionalRole: false
}, {
    name: "order",
    crud: ["create", "read", "update"],
    isAdditionalRole: false
}, {
    name: "hardener",
    crud: ["read"],
    isAdditionalRole: false
}, {
    name: "customReceipts",
    isAdditionalRole: true,
    isAuthorizedForAdditionalRole: true
}
]

// laborator
export const userRolesLaboratory = [{
    name: "base",
    crud: ["create", "read", "update", "delete"],
    isAdditionalRole: false
}, {
    name: "package",
    crud: ["create", "read", "update", "delete"],
    isAdditionalRole: false
}, {
    name: "color",
    crud: ["create", "read", "update", "delete"],
    isAdditionalRole: false
}, {
    name: "pigment",
    crud: ["create", "read", "update", "delete"],
    isAdditionalRole: false
}, {
    name: "receipt",
    crud: ["create", "read", "update", "delete"],
    isAdditionalRole: false
}, {
    name: "toning",
    crud: ["create", "read", "update", "delete"],
    isAdditionalRole: false
}, {
    name: "product",
    crud: ["create", "read", "update", "delete"],
    isAdditionalRole: false
}, {
    name: "sampleCard",
    crud: ["create", "read", "update", "delete"],
    isAdditionalRole: false
}, {
    name: "hardener",
    crud: ["create", "read", "update", "delete"],
    isAdditionalRole: false
}, {
    name: "priceList",
    isAdditionalRole: true,
    isAuthorizedForAdditionalRole: true
}, {
    name: "copyReceipt",
    isAdditionalRole: true,
    isAuthorizedForAdditionalRole: true
}
]

// manazer BALT
export const userRolesBALT = [{
    name: "base",
    crud: ["create", "read", "update", "delete"],
    isAdditionalRole: false
}, {
    name: "package",
    crud: ["create", "read", "update", "delete"],
    isAdditionalRole: false
}, {
    name: "color",
    crud: ["create", "read", "update", "delete"],
    isAdditionalRole: false
}, {
    name: "pigment",
    crud: ["create", "read", "update", "delete"],
    isAdditionalRole: false
}, {
    name: "seller",
    crud: ["create", "read", "update", "delete"],
    isAdditionalRole: false
}, {
    name: "customer",
    crud: ["read"],
    isAdditionalRole: false
}, {
    name: "receipt",
    crud: ["create", "read", "update", "delete"],
    isAdditionalRole: false
}, {
    name: "toning",
    crud: ["create", "read", "update", "delete"],
    isAdditionalRole: false
}, {
    name: "user",
    crud: ["create", "read", "update", "delete"],
    isAdditionalRole: false
}, {
    name: "product",
    crud: ["create", "read", "update", "delete"],
    isAdditionalRole: false
}, {
    name: "sampleCard",
    crud: ["create", "read", "update", "delete"],
    isAdditionalRole: false
}, {
    name: "order",
    crud: ["create", "read", "update", "delete"],
    isAdditionalRole: false
}, {
    name: "discount",
    crud: ["create", "read", "update"],
    isAdditionalRole: false
}, {
    name: "hardener",
    crud: ["create", "read", "update", "delete"],
    isAdditionalRole: false
}, {
    name: "priceList",
    isAdditionalRole: true,
    isAuthorizedForAdditionalRole: true
}, {
    name: "customReceipts",
    isAdditionalRole: true,
    isAuthorizedForAdditionalRole: true
}
]

// manazer ZO
export const userRolesZO = [{
    name: "base",
    crud: ["read"],
    isAdditionalRole: false
}, {
    name: "package",
    crud: ["read"],
    isAdditionalRole: false
}, {
    name: "color",
    crud: ["read"],
    isAdditionalRole: false
}, {
    name: "pigment",
    crud: ["read"],
    isAdditionalRole: false
}, {
    name: "seller",
    crud: ["create","read","update"],
    isAdditionalRole: false
}, {
    name: "customer",
    crud: ["read"],
    isAdditionalRole: false
}, {
    name: "receipt",
    crud: ["read"],
    isAdditionalRole: false
}, {
    name: "toning",
    crud: ["read"],
    isAdditionalRole: false
}, {
    name: "user",
    crud: ["create", "read", "update"],
    isAdditionalRole: false
}, {
    name: "product",
    crud: ["read"],
    isAdditionalRole: false
}, {
    name: "sampleCard",
    crud: ["read"],
    isAdditionalRole: false
}, {
    name: "order",
    crud: ["create","read","update"],
    isAdditionalRole: false
}, {
    name: "discount",
    crud: ["create", "read", "update"],
    isAdditionalRole: false
}, {
    name: "hardener",
    crud: ["read"],
    isAdditionalRole: false
}, {
    name: "priceList",
    isAdditionalRole: true,
    isAuthorizedForAdditionalRole: true
}, {
    name: "customReceipts",
    isAdditionalRole: true,
    isAuthorizedForAdditionalRole: true
}
]

export const userRolesNewUser = [{
    name: "base",
    crud: [],
    isAdditionalRole: false
}, {
    name: "package",
    crud: [],
    isAdditionalRole: false
}, {
    name: "color",
    crud: [],
    isAdditionalRole: false
}, {
    name: "pigment",
    crud: [],
    isAdditionalRole: false
}, {
    name: "seller",
    crud: [],
    isAdditionalRole: false
}, {
    name: "customer",
    crud: [],
    isAdditionalRole: false
}, {
    name: "receipt",
    crud: [],
    isAdditionalRole: false
}, {
    name: "toning",
    crud: [],
    isAdditionalRole: false
}, {
    name: "user",
    crud: [],
    isAdditionalRole: false
}, {
    name: "product",
    crud: [],
    isAdditionalRole: false
}, {
    name: "sampleCard",
    crud: [],
    isAdditionalRole: false
}, {
    name: "order",
    crud: [],
    isAdditionalRole: false
}, {
    name: "discount",
    crud: [],
    isAdditionalRole: false
}, {
    name: "hardener",
    crud: [],
    isAdditionalRole: false
}
]